import './styles.scss'
import './CreateAccount.module.scss'
import { stepsStoreConfig } from '../../../entities/Stepper2/config/CF/stepsStoreConfig'
import { Store, useStore } from '../../../entities/Stepper2/module/rootStore'
import Stepper from '../../../entities/Stepper2/ui/Stepper'
import createApiFunctions from '../../../entities/Stepper2/api/factoryApi'
import { apiConfig } from '../../../entities/Stepper2/config/CF/apiConfig'

console.log('123')
const stepsStoreApi = createApiFunctions({
  apiConfig,
  abTest: 'b',
  // isTest: true
})

Store.setConfig({
  stepsStoreConfig,
  stepsStoreApi
})

const CreateAccount = () => {

  return (
    <Stepper />
  )
}

export default CreateAccount